import React from 'react';

export default [
  {
    path: '/student/books',
    name: 'Sách điện tử',
    miniName: 'T',
    component: React.lazy(() => import('pages/Student/Books')),
    icon: 'fas fa-book text-blue',
    layout: '/lms',
    exact: true,
    roles: ['student'],
    sortOrder: 100,
    showInSidebar: true,
  },
  {
    path: '/student/classes',
    name: 'Lớp học',
    miniName: 'C',
    component: React.lazy(() => import('pages/Student/Classes/Classes')),
    icon: 'fas fa-graduation-cap text-green',
    layout: '/lms',
    sortOrder: 102,
    exact: true,
    roles: ['student'],
    showInSidebar: true,
  },
  {
    path: '/student/classes/:classId',
    name: 'Lớp học',
    miniName: 'C',
    component: React.lazy(() => import('pages/Student/Classes/ClassDetails')),
    icon: 'fas fa-graduation-cap text-green',
    layout: '/lms',
    exact: true,
    roles: ['student'],
    showInSidebar: false,
    sortOrder: 0,
  },
  // BEANS
  // {
  //   path: '/student/beans',
  //   name: 'Beans',
  //   miniName: 'B',
  //   component: React.lazy(() => import('pages/Student/Beans')),
  //   icon: 'fas fa-book text-orange',
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['student'],
  //   showInSidebar: false,
  //   sortOrder: 0,
  // },
  // {
  //   path: '/students/beans/payment/package/:packageId',
  //   name: 'Beans Payment',
  //   miniName: 'B',
  //   component: React.lazy(()=>import('pages/Student/Beans/Payment')),
  //   icon: 'fas fa-book text-orange',
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['student'],
  //   showInSidebar: false,
  //   sortOrder: 0,
  // },

  // BEGIN: CLASSWORK

  {
    path: '/student/classes/:classId/classwork/assignments/:assignmentId/details',
    component: React.lazy(() => import('pages/Student/Classwork/Assignments/Details')),
    layout: '/lms',
    exact: true,
    roles: ['student'],
  },

  // END: CLASSWORK

  // worksheet space
  {
    path: '/student/worksheet/exercise/:id',
    component: React.lazy(() => import('modules/WorkSheet/CanvasToolPlus/ExcercisePage')),
    layout: '/lms',
    exact: true,
    roles: ['student'],
  },
];
